module.exports = __webpack_public_path__ + "img/HeartLoad.42f905b1.gif";